import React from 'react';
import { Row, Col, FormControl, HelpBlock } from 'react-bootstrap';
// css
import '../../styles/ordersStyles.css';
import '../../../styles/commonStyles.css';

class AnagraficaCliente extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cf_alert: null,
      editMode: (this.props.editMode) ? true : null
    }

    this.handleOnCodiceFiscaleChange = this.handleOnCodiceFiscaleChange.bind(this);
  }

  render() {
    const { cf_alert, editMode } = this.state;
    const { panCliente } = this.props;

    return (
      <Row className="noNegativeMargin">
        <Col xs={12} lg={3}>
          <label htmlFor="nome">Nome</label>
          <FormControl
            id="nome" name="nome" type="text"
            maxLength="255" autoComplete="off"
            data-caption="Nome" required
            defaultValue={editMode ? panCliente["nome"] : ''}
          />
        </Col>

        <Col xs={12} lg={3}>
          <label htmlFor="cognome">Cognome</label>
          <FormControl
            id="cognome" name="cognome" type="text"
            maxLength="255" autoComplete="off"
            data-caption="Cognome" required
            defaultValue={editMode ? panCliente["cognome"] : ''}
          />
        </Col>

        <Col xs={12} lg={3}>
          <label htmlFor="cf">Codice fiscale</label>
          <FormControl
            id="cf" name="cf" type="text"
            maxLength="16" autoComplete="off"
            onChange={this.handleOnCodiceFiscaleChange}
            data-caption="Codice fiscale" required
            defaultValue={editMode ? panCliente["cf"] : ''}
          />
          <HelpBlock className="colorRed">{cf_alert}</HelpBlock>
        </Col>

        <Col xs={12} lg={3}>
          <label htmlFor="iva">Partita IVA</label>
          <FormControl
            id="iva" name="iva" type="text"
            maxLength="255" autoComplete="off"
            data-caption="Partita IVA"
            defaultValue={editMode ? panCliente["iva"] : ''}
          />
        </Col>
      </Row>
    );
  }

  handleOnCodiceFiscaleChange(e) {
    const field = e.target;
    const style = 'invalid-field';
    const errorMessage = 'Codice fiscale non valido';
    field.value = field.value.toUpperCase();

    if (field.value.length === 16) {
      if (CheckCodiceFiscale(field.value)) {
        field.setCustomValidity('');
        if (field.classList.contains(style))
          field.classList.remove(style);
        this.setState({ [field.name + "_alert"]: '' });
      } else {
        field.setCustomValidity(errorMessage);
        field.classList.add(style);
        this.setState({ [field.name + "_alert"]: [errorMessage] });
      }
    } else {
      field.setCustomValidity(errorMessage);
      field.classList.add(style);
      this.setState({ [field.name + "_alert"]: [errorMessage] });
    }

  }
}

// Validatore del codice fiscale
function CheckCodiceFiscale(cf) {
  const regex = /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/;

  if (!regex.test(cf)) {
    return false;
  }

  const set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const setPari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const setDispari = "BAKPLCQDREVOSFTGUHMINJWZYX";
  let s = 0;

  for (let i = 1; i <= 13; i += 2) {
    s += setPari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
  }

  for (let i = 0; i <= 14; i += 2) {
    s += setDispari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
  }

  return (s % 26 === cf.charCodeAt(15) - 'A'.charCodeAt(0));
}

export default AnagraficaCliente;


// WEBPACK FOOTER //
// ./src/cmp/Orders/Panels/PanelCliente/AnagraficaCliente.js